import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Check, Copy } from 'sutra/components/Icons'
import { gray } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'

const COPIED_DISPLAY_MS = 3000

export interface CopyButtonProps {
  // Read at click time, so it can come from the rendered DOM.
  getText: () => string
  onCopy?: () => void
}

const Button = styled.button`
  display: inline-flex;
  flex: none;
  padding: 2px;
  color: inherit;
  background: none;
  border: 0;
  border-radius: ${radii.xs}px;
  cursor: pointer;

  &:hover {
    background: ${gray[100]};
  }
`

export const CopyButton = ({
  getText,
  onCopy,
}: CopyButtonProps): React.ReactElement => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return undefined
    const timer = setTimeout(() => setCopied(false), COPIED_DISPLAY_MS)
    return () => clearTimeout(timer)
  }, [copied])

  const label = copied ? 'Copied' : 'Copy'
  const Icon = copied ? Check : Copy
  return (
    <Button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => {
        void navigator.clipboard.writeText(getText()).then(() => {
          setCopied(true)
          onCopy?.()
        })
      }}
    >
      <Icon width={14} height={14} />
    </Button>
  )
}
